import type { SecondaryDimensionValues } from '@revelio/core';

import { FilterId, type PrimaryFilterId } from '../../../filters/types/filters';

/** When a column is not the same dimension as the page's primary unit of analysis, a dimension column can be two
 * things:
 * 1. A primary top-N dimension
 * 2. A segmentation of the primary dimension
 * Typically a top-N dimension will need to be the chart's primary dimension, and a segment will be secondary to
 * an already defined primary dimension. When it is the top-N dimension, the label could be Top {dimension}, but
 * would only be the dimension name when it's a segment. To keep things simpler for now, we'll keep the label as
 * just the dimension name, and can optionally add in label prefixes with more complex checks later. */
export const getColumnDimensionLabel = (
  dimension: SecondaryDimensionValues
): string => {
  switch (dimension) {
    case 'company':
      return 'Company';
    case 'geography':
      return 'Geography';
    case 'role':
      return 'Role';
    case 'rics':
      return 'Industry';
    case 'skills':
      return 'Skills';
    case 'seniority':
      return 'Seniority';
    case 'education':
      return 'Education';
    case 'ethnicity':
      return 'Ethnicity';
    case 'gender':
      return 'Gender';
    case 'competitors':
      return 'Competitors';
    case 'timeseries':
      return 'Time';
  }
};

export const getPrimaryDimension = (
  primaryFilterId: PrimaryFilterId
): SecondaryDimensionValues => {
  switch (primaryFilterId) {
    case FilterId.COMPANY:
      return 'company';
    case FilterId.GEOGRAPHY:
      return 'geography';
    case FilterId.ROLE:
      return 'role';
  }
};
